import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=a8b3d0b4&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./BetaBadge.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b3d0b4",
  null
  
)

export default component.exports